import { useMenuContext } from "../context/MenuContext";
import type { MenuResponse } from "../services/types/menu";

export const useGetMenuResponse = (): MenuResponse | null => {
  const { menu: menuResponse } = useMenuContext();

  return menuResponse;
};
